export default "__VITE_ASSET__5afc50a2__"